import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Variable, } from '../../../../../_entity.js';
import { ICONS } from '@app/styles';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DropDown_VariableV3 } from '../../../../../_entity/variable/ui-components.js';
import './Component_AttributeInstanceParents.scss';
import { variableType_Attribute, variableType_AttributeInstance, variableType_PrecipitatingFactor, variableType_RelievingFactor } from '@app/hcs-shared/core';
export class Component_AttributeInstanceParents extends ComponentSync {
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.parentVariable = ModuleFE_Variable.cache.unique(nextProps.parentVariableId);
        if (!state.parentVariable)
            throw new MUSTNeverHappenException(`Could not find variable for id ${nextProps.parentVariableId}`);
        if (nextProps.parentAttributeId) {
            state.parentAttribute = ModuleFE_Variable.cache.unique(nextProps.parentAttributeId);
            if (!state.parentAttribute)
                throw new MUSTNeverHappenException(`Could not find variable for id ${nextProps.parentAttributeId}`);
        }
        state.busy ??= false;
        return state;
    }
    // ######################### Logic #########################
    onAttributeSelected = (attribute) => {
        this.setState({ busy: true, parentAttribute: attribute }, () => {
            try {
                this.props.onAttributeSelected?.(attribute);
            }
            catch (err) {
                this.logError(err);
            }
            finally {
                if (this.mounted)
                    this.setState({ busy: false });
            }
        });
    };
    // ######################### Render #########################
    render() {
        return _jsxs(LL_H_C, { className: 'attribute-instance-parents', children: [this.renderVariableView(this.state.parentVariable), _jsx(ICONS.advisor_v5_plus.component, {}), this.renderVariableView(this.state.parentAttribute)] });
    }
    renderVariableView = (variable) => {
        const view = variable ? 'variable' : 'selector';
        return _jsx(Component_SwitchView, { mode: view, modes: [
                {
                    key: 'variable',
                    renderer: () => this.renderVariableCard(variable),
                },
                {
                    key: 'selector',
                    renderer: () => this.renderVariableSelector(),
                }
            ] });
    };
    renderVariableCard = (variable) => {
        const className = _className('attribute-instance-parents__variable-card', this.props.onVariableClick && 'clickable');
        return _jsx(LL_V_L, { className: className, onClick: () => this.props.onVariableClick?.(variable), children: variable.name });
    };
    renderVariableSelector = () => {
        const attributeInstances = ModuleFE_Variable.cache.filter(variable => {
            return variable.type === variableType_AttributeInstance
                && variable.parents.variableId === this.state.parentVariable._id;
        });
        const notAllowedAttributeIds = attributeInstances.map(variable => variable.parents.attributeId);
        const allowedAttributeTypes = [variableType_Attribute, variableType_RelievingFactor, variableType_PrecipitatingFactor];
        return _jsx(DropDown_VariableV3.selectable, { queryFilter: variable => {
                return allowedAttributeTypes.includes(variable.type) && !notAllowedAttributeIds.includes(variable._id);
            }, onSelected: this.onAttributeSelected });
    };
}
//# sourceMappingURL=Component_AttributeInstanceParents.js.map